import { CanActivate, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { UserSettingsService } from '../../settings/service/user-settings.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class BooleanSettingGuard implements CanActivate {

  protected mode: BooleanSettingGuardMode = BooleanSettingGuardMode.ANY_TRUE;

  constructor(protected userSettings: UserSettingsService, protected router: Router) { }

  protected abstract get settingsValues(): boolean[];

  protected get checkSettings(): Observable<boolean> {
    for (const value of this.settingsValues) {
      if (this.mode == BooleanSettingGuardMode.ANY_TRUE && value)
        return of(true);
      else if (this.mode == BooleanSettingGuardMode.ALL_TRUE && !value)
        return of(false);
    }

    if (this.mode == BooleanSettingGuardMode.ANY_TRUE)
      return of(false);
    else if (this.mode == BooleanSettingGuardMode.ALL_TRUE)
      return of(true);
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.checkSettings
      .pipe(
        tap(canActivate => {
          if (!canActivate)
            void this.router.navigate(['/404']);
        })
      );
  }
}

export enum BooleanSettingGuardMode {
  ALL_TRUE, ANY_TRUE
}
